import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MerchantsRoutingModule } from './merchants-routing.module';
import { MerchantsComponent } from './merchants.component';
import { SharedModule } from '@app/@shared';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MerchantTableComponent } from './components/merchant-table/merchant-table.component';
import { MerchantsApiService } from '@app/areas/merchants/services/merchants.api.service';
import { MerchantFormComponent } from './forms/merchant-form/merchant-form.component';
import { MerchantFormService } from '@app/areas/merchants/services/merchant-form.service';
import { CardModule } from 'primeng/card';
import { NewMerchantComponent } from './components/new-merchant/new-merchant.component';
import { MerchantPaymentTypeControlComponent } from './controls/merchant-payment-type-control/merchant-payment-type-control.component';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MerchantEnrollmentConfirmationComponent } from './components/merchant-enrollment-confirmation/merchant-enrollment-confirmation.component';
import { MerchantSmsPriceControlComponent } from './controls/merchant-sms-price-control/merchant-sms-price-control.component';
import { MerchantDetailComponent } from './components/merchant-detail/merchant-detail.component';
import { MerchantNoAccessComponent } from './components/merchant-no-access/merchant-no-access.component';
import { MerchantAccessGuard } from '@app/areas/merchants/guards/merchant-access.guard';
import { LocationTableComponent } from './components/location-table/location-table.component';
import { NewLocationComponent } from './components/new-location/new-location.component';
import { LocationDetailComponent } from './components/location-detail/location-detail.component';
import { LocationFormComponent } from './forms/location-form/location-form.component';
import { LocationsApiService } from '@app/areas/merchants/services/locations.api.service';
import { LocationFormService } from '@app/areas/merchants/services/location-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { EmployeeTableComponent } from './components/employee-table/employee-table.component';
import { EmployeesApiService } from '@app/areas/merchants/services/employees.api.service';
import { NewEmployeeComponent } from './components/new-employee/new-employee.component';
import { EmployeeDetailComponent } from './components/employee-detail/employee-detail.component';
import { EmployeeFormComponent } from './forms/employee-form/employee-form.component';
import { EmployeeFormService } from '@app/areas/merchants/services/employee-form.service';
import { MerchantOverviewComponent } from './components/merchant-overview/merchant-overview.component';
import { MerchantOverviewFormComponent } from './forms/merchant-overview-form/merchant-overview-form.component';
import { MerchantOverviewFormService } from '@app/areas/merchants/services/merchant-overview-form.service';
import { RepresentativesApiService } from '@app/areas/admin/representatives/services/representatives.api.service';
import { DeviceTableComponent } from './components/device-table/device-table.component';
import { NewDeviceComponent } from './components/new-device/new-device.component';
import { DeviceDetailComponent } from './components/device-detail/device-detail.component';
import { DeviceFormComponent } from './forms/device-form/device-form.component';
import { DevicesApiService } from '@app/areas/merchants/services/devices.api.service';
import { DeviceFormService } from '@app/areas/merchants/services/device-form.service';
import { AccessTableComponent } from './components/access-table/access-table.component';
import { OrderTableComponent } from './components/order-table/order-table.component';
import { OrdersApiService } from '@app/areas/merchants/services/orders.api.service';

@NgModule({
  declarations: [MerchantsComponent],
  imports: [
    CommonModule,
    MerchantsRoutingModule,
    SharedModule,
    TableModule,
    ButtonModule,
    MerchantTableComponent,
    MerchantFormComponent,
    NewMerchantComponent,
    MerchantPaymentTypeControlComponent,
    MerchantEnrollmentConfirmationComponent,
    MerchantSmsPriceControlComponent,
    MerchantDetailComponent,
    MerchantNoAccessComponent,
    LocationTableComponent,
    NewLocationComponent,
    LocationDetailComponent,
    LocationFormComponent,
    EmployeeTableComponent,
    NewEmployeeComponent,
    EmployeeDetailComponent,
    EmployeeFormComponent,
    MerchantOverviewComponent,
    MerchantOverviewFormComponent,
    DeviceTableComponent,
    NewDeviceComponent,
    DeviceDetailComponent,
    DeviceFormComponent,
    AccessTableComponent,
    OrderTableComponent,
    CardModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
  ],
  providers: [
    MerchantsApiService,
    MerchantAccessGuard,
    MerchantFormService,
    LocationsApiService,
    LocationFormService,
    EmployeesApiService,
    EmployeeFormService,
    MerchantOverviewFormService,
    RepresentativesApiService,
    DevicesApiService,
    DeviceFormService,
    OrdersApiService,
  ],
})
export class MerchantsModule {}
